import { IQuote } from "../../shared/types";

export const defaultQuoteEmailMessage = (customerName: string) => `Thank you for the opportunity to support ${customerName}. I've included a quote with the proposed licensing, quantities, and pricing for your review.\n\nPlease let me know if you have any questions or would like to review the quote together.`;

export const quoteEmailSubject = (quote: Pick<IQuote, "quote_id" | "name">) => quote.name
  ? `Your Quote: ${quote.name} (CSP-CP-${quote.quote_id})`
  : `Your Quote: CSP-CP-${quote.quote_id}`;
